import AOS from "../../libraries/aos";

((Drupal, drupalSettings) => {
  Drupal.behaviors.wwf_aos = {
    attach(context) {
      once("animateOnScroll", "body", context).forEach(() => {
        const animations = Object.values(drupalSettings.aos);
        const animationList = animations.reduce((carry, element) => {
          const json = JSON.parse(element);
          return carry.concat(json);
        }, JSON.parse("[]"));

        animationList.forEach((elementSettings) => {
          if (elementSettings.xpath) {
            const foundElement = document.evaluate(
              elementSettings.xpath,
              document,
              null,
              XPathResult.FIRST_ORDERED_NODE_TYPE,
              null
            ).singleNodeValue;

            if (foundElement) {
              foundElement.setAttribute("data-aos", elementSettings.effect);
              foundElement.setAttribute(
                "data-aos-duration",
                elementSettings.duration
              );
              foundElement.setAttribute(
                "data-aos-easing",
                elementSettings.easing
              );
              foundElement.setAttribute(
                "data-aos-anchor-placement",
                elementSettings.placement
              );
              foundElement.setAttribute(
                "data-aos-delay",
                elementSettings.delay
              );
              foundElement.setAttribute(
                "data-aos-mirror",
                elementSettings.mirror
              );
            }
          }
          function addAosAttributes(element) {
            element.setAttribute("data-aos", elementSettings.effect);
            element.setAttribute("data-aos-duration", elementSettings.duration);
            element.setAttribute("data-aos-easing", elementSettings.easing);
            element.setAttribute(
              "data-aos-anchor-placement",
              elementSettings.placement
            );
            element.setAttribute("data-aos-delay", elementSettings.delay);
            element.setAttribute("data-aos-mirror", elementSettings.mirror);
          }
          if (elementSettings.selector) {
            // handles no matches by default
            document
              .querySelectorAll(elementSettings.selector)
              .forEach(addAosAttributes);
          }
        });

        AOS.init();
      });
    },
  };
})(Drupal, drupalSettings);
